import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OperationalDashboardComponent } from './operational-dashboard.component';

const routes: Routes = [ { path: '', component: OperationalDashboardComponent },];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OperationalDashboardRoutingModule { }
